import { useRef, useState } from "react";
import { Download } from "lucide-react";

import VideoAnalysisPanel from "pages/files/video/analysis/VideoAnalysisPanel";
import { getAdminFileDownloadUrl } from "lib/api/adminFiles";
import { downloadAdminFile } from "lib/utils/adminFileDownload";

export default function AdminVideoAnalysisPanel({ file, fileId, t }) {
  const [selectedFrame, setSelectedFrame] = useState([null, null]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const uploadId = file?.upload_id || fileId;

  const refs = {
    frame_ref_1: useRef(null),
    frame_ref_2: useRef(null),
    graph_ref_1: useRef(null),
    graph_ref_2: useRef(null),
    spectrogram_ref_1: useRef(null),
    spectrogram_ref_2: useRef(null),
    waveform_ref_1: useRef(null),
    waveform_ref_2: useRef(null),
  };

  const handleOriginalDownload = async () => {
    if (!uploadId) return;

    setIsDownloading(true);
    setDownloadError("");

    try {
      const result = await downloadAdminFile(
        getAdminFileDownloadUrl(uploadId),
        file?.file_name || "",
      );

      if (!result?.success) {
        setDownloadError(result?.message || t("adminFiles.downloadError"));
      }
    } catch (error) {
      setDownloadError(error?.message || t("adminFiles.downloadError"));
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="adminFileViewer">
      <div className="adminFileViewer__toolbar">
        <button
          type="button"
          className="adminFileViewer__downloadBtn"
          onClick={handleOriginalDownload}
          disabled={isDownloading || !uploadId}
        >
          <Download size={16} aria-hidden="true" />
          {isDownloading
            ? t("adminFiles.actions.downloading")
            : t("adminFiles.originalDownload")}
        </button>
        {downloadError ? (
          <span className="adminFileViewer__error">{downloadError}</span>
        ) : null}
      </div>

      <VideoAnalysisPanel
        file={file}
        refs={refs}
        selectedFrame={selectedFrame}
        setSelectedFrame={setSelectedFrame}
        t={t}
      />
    </div>
  );
}
